import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  return (
    <div className="home">
      <section className="hero">
        <div className="hero-content">
          <h1> Revive Your Body, Elevate Your Health </h1>
          <p> Enjoy hand-crafted smoothies, juices, and protein balls, designed by a nutritionist
             for optimal health, energy & recovery.</p>
          <div className="cta-buttons">
            <Link to="/menu" className="cta-button">View Menu</Link>
            <Link to="/order" className="cta-button primary">Order Now</Link>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="feature">
          <div className="feature-icon">🥤</div>
          <h2>Fresh Smoothies</h2>
          <p>Made with organic fruits and vegetables, our smoothies are packed with nutrients.</p>
        </div>
        <div className="feature">
          <div className="feature-icon">🧃</div>
          <h2>Cold-Pressed Juices</h2>
          <p>Preserving enzymes and nutrients through our cold-press process.</p>
        </div>
        <div className="feature">
          <div className="feature-icon">🥜</div>
          <h2>Protein Balls</h2>
          <p>Delicious, energy-packed treats made with natural ingredients.</p>
        </div>
      </section>

      <section className="about-preview">
        <div className="about-text">
          <h2>Our Wellness Philosophy</h2>
          <p>At Revive, we believe that what you put into your body matters. That's why we source the freshest, highest quality ingredients for all our products.</p>
          <p>Our team is passionate about creating delicious, nutrient-dense options that support your wellness journey.</p>
          <Link to="/about" className="text-link">Learn more about us</Link>
        </div>
        <div className="about-image">
          {/* Placeholder for image */}
          <div className="image-placeholder">Wellness Center Image</div>
        </div>
      </section>
    </div>
  );
}

export default Home;